export function sharedUiIconLib(): string {
    return 'shared-ui-icon-lib';
}
